import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { BrowserHistoryReplace } from '../../shared/routing/BrowserHistoryReplace';

import { TodoNavbar } from './components/Navbar';

import { Todo } from './index';

export const TodoRoute = (
    <Route
        path="/todo"
        render={({ match }) => (
            <React.Fragment>
                <Route component={TodoNavbar} />
                <Switch>
                    <Route path={`${match.url}/:period`} render={() => <Todo />} />
                    <Route render={() => <BrowserHistoryReplace to={`${match.url}/today`} />} />
                </Switch>
            </React.Fragment>
        )}
    />
);
